interface IconProps {
  size?: number;
  height?: number;
  width?: number;
  fill?: string;
}

export const Trc20Icon = ({
  size,
  height,
  width,
  fill,
  ...props
}: IconProps) => {
  return (
    <svg
      width={width || size}
      height={height || size}
      viewBox="0 0 26 26"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <rect
        width="26"
        height="26"
        rx="4"
        fill={fill || "url(#paint0_linear_2_37391)"}
        fillOpacity="0.15"
      />
      <g clipPath="url(#clip0_2_37391)">
        <path
          d="M13.4618 15.2148L14.2963 14.3798C15.6789 12.9963 15.6789 10.7532 14.2963 9.36967C12.9136 7.98615 10.6719 7.98615 9.28925 9.36967L7.62024 11.0397C6.23759 12.4232 6.23759 14.6663 7.62024 16.0499C8.26143 16.6914 9.08738 17.0355 9.92672 17.082"
          stroke="url(#paint1_linear_2_37391)"
          strokeWidth="1.5"
          strokeLinecap="round"
        />
        <path
          d="M12.5382 10.7852L11.7037 11.6202C10.3211 13.0037 10.3211 15.2468 11.7037 16.6303C13.0864 18.0138 15.3281 18.0138 16.7108 16.6303L18.3798 14.9603C19.7624 13.5768 19.7624 11.3337 18.3798 9.95015C17.7386 9.30855 16.9126 8.96449 16.0733 8.91797"
          stroke="url(#paint2_linear_2_37391)"
          strokeWidth="1.5"
          strokeLinecap="round"
        />
      </g>
      <defs>
        <linearGradient
          id="paint0_linear_2_37391"
          x1="13"
          y1="0"
          x2="13"
          y2="26"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#2998FF" />
          <stop offset="1" stopColor="#1673DF" />
        </linearGradient>
        <linearGradient
          id="paint1_linear_2_37391"
          x1="10.9583"
          y1="8.33203"
          x2="10.9583"
          y2="17.082"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#2998FF" />
          <stop offset="1" stopColor="#1673DF" />
        </linearGradient>
        <linearGradient
          id="paint2_linear_2_37391"
          x1="15.0417"
          y1="8.91797"
          x2="15.0417"
          y2="17.668"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#2998FF" />
          <stop offset="1" stopColor="#1673DF" />
        </linearGradient>
        <clipPath id="clip0_2_37391">
          <rect
            width="14"
            height="14"
            fill="white"
            transform="translate(6 6)"
          />
        </clipPath>
      </defs>
    </svg>
  );
};

export default Trc20Icon;
